import { Container, Divider, Typography } from '@mui/material'
import React from 'react'

const FooterSection = () => {
    return (
        <Container component='footer' maxWidth='lg' sx={{py:4}}>
            <Typography variant='body2'>Shopify Challenge</Typography>
            <Divider sx={{my:1}}/>
            <Typography variant='body1'>Made by Patrick Valera 2022</Typography>
            <Typography variant='body1'>Bootstrapped with NextJS and Material UI</Typography>
        </Container>
    )
}

export default FooterSection